import { Input } from "@chakra-ui/input";
import { Box } from "@chakra-ui/layout";
import { Col, Row } from "antd";
import { AreaComumUnidadeBloqueioForm } from "core/features/area-comum/typings";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import moment from "moment";
import {
  Control,
  UseFormGetValues,
  UseFormSetValue,
  UseFormTrigger,
} from "react-hook-form";
import Field from "ui/components/Input/Field";
import SelectDestinos from "ui/components/SelectDestinos";
import { Textarea } from "@chakra-ui/react";
import SelectAreaComum from "components/Input/SelectAreaComum";

interface FormBloqueioProps {
  control: Control<AreaComumUnidadeBloqueioForm, object>;
  setValue: UseFormSetValue<AreaComumUnidadeBloqueioForm>;
  getValues: UseFormGetValues<AreaComumUnidadeBloqueioForm>;
  form: AreaComumUnidadeBloqueioForm;
  trigger: UseFormTrigger<AreaComumUnidadeBloqueioForm>;
}

function FormBloqueio({
  control,
  setValue,
  getValues,
  form,
  trigger,
}: FormBloqueioProps) {
  const { tenant } = useCurrentTenant();

  return (
    <form id="bloquear-unidade-area-comum">
      <Box mt={-4}>
        <SelectDestinos
          control={control}
          form={form}
          setValue={setValue}
          getValues={getValues}
          tenantId={tenant.id}
          showEmail={false}
          label="Bloquear: "
        />
      </Box>
      <Box px={1} mt={4}>
        <Box as={Row} mb="16px" gutter={16}>
          <Col sm={12}>
            <Field
              label="Início bloqueio"
              control={control}
              name="dataInicio"
              rules={{ required: "Campo obrigatório" }}
              render={({ field, isInvalid }) => (
                <Input
                  onChange={(ev) => {
                    if (form.dataFim && ev.target.value) {
                      const _diasBloqueio = moment(form.dataFim).diff(
                        moment(ev.target.value),
                        "days"
                      );
                      setValue("diasBloqueio", _diasBloqueio);
                    }

                    if (moment(ev.target.value).isAfter(form.dataFim)) {
                      setValue(
                        "dataFim",
                        moment(ev.target.value).format("YYYY-MM-DD")
                      );
                      setValue("diasBloqueio", 0);
                    }

                    field.onChange(ev.target.value);
                  }}
                  isInvalid={isInvalid}
                  value={field.value}
                  type="date"
                />
              )}
            />
          </Col>

          <Col sm={12}>
            <Field
              label="Período do bloqueio (dias)"
              control={control}
              name="diasBloqueio"
              render={({ field, isInvalid }) => (
                <Input
                  value={`${field.value || 0}`}
                  type="number"
                  onChange={(ev) => {
                    const val = ev.target.value
                      ? Number(ev.target.value.replace(/^\D/g, ""))
                      : undefined;
                    if (form.dataInicio) {
                      const endDate = moment(form.dataInicio)
                        .add(Number(val || 0), "days")
                        .format("YYYY-MM-DD");
                      setValue("dataFim", endDate);
                      trigger("dataFim");
                    }

                    field.onChange(val);
                  }}
                  isInvalid={isInvalid}
                />
              )}
            />
          </Col>
        </Box>

        <Box as={Row} mb="16px" gutter={16}>
          <Col sm={12}>
            <Field
              label="Fim bloqueio"
              control={control}
              name="dataFim"
              render={({ field, isInvalid }) => (
                <Input
                  onChange={(ev) => {
                    if (form.dataInicio && ev.target.value) {
                      const _diasBloqueio = moment(ev.target.value).diff(
                        moment(form.dataInicio),
                        "days"
                      );
                      setValue("diasBloqueio", _diasBloqueio);
                    }
                    field.onChange(ev.target.value);
                  }}
                  isInvalid={isInvalid}
                  value={field.value}
                  type="date"
                  min={form.dataInicio ? form.dataInicio : undefined}
                />
              )}
            />
          </Col>

          <Col sm={12}>
            <Field
              label="Área comum"
              control={control}
              name="areaComumId"
              render={({ field, isInvalid }) => (
                <SelectAreaComum isInvalid={isInvalid} {...field} />
              )}
            />
          </Col>
        </Box>

        <Field
          label="Motivo"
          control={control}
          name="motivo"
          render={({ field, isInvalid }) => (
            <Textarea
              isInvalid={isInvalid}
              className="chakra-input"
              rows={3}
              placeholder="Digite..."
              {...field}
            />
          )}
        />
      </Box>
    </form>
  );
}

export default FormBloqueio;
